import * as React from 'react';

import {Provider} from 'react-redux';
import {CommentsDashboardComponent} from './Dashboard';
import {store} from './store';

export function CommentsDashboardContainer() {
  return (
    <Provider store={store}>
      <CommentsDashboardComponent />
    </Provider>
  );
}
